import React from 'react';
import Icon, { Props } from './icon';

export const RecordingIndicator: React.FC<Props> = (props: Props) => {
  return (
    <Icon {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.334 5.34999C10.4522 5.34999 5.684 10.1182 5.684 16C5.684 21.8818 10.4522 26.65 16.334 26.65C22.2158 26.65 26.984 21.8818 26.984 16C26.984 10.1182 22.2158 5.34999 16.334 5.34999ZM2.984 16C2.984 8.62699 8.961 2.64999 16.334 2.64999C23.707 2.64999 29.684 8.62699 29.684 16C29.684 23.373 23.707 29.35 16.334 29.35C8.961 29.35 2.984 23.373 2.984 16Z"
      />
      <path d="M16.3346 22.6667C20.0165 22.6667 23.0013 19.6819 23.0013 16C23.0013 12.3181 20.0165 9.33333 16.3346 9.33333C12.6527 9.33333 9.66793 12.3181 9.66793 16C9.66793 19.6819 12.6527 22.6667 16.3346 22.6667Z" />
    </Icon>
  );
};

export default React.memo(RecordingIndicator);
